import React from "react";
import ReactPlayer from "react-player";

interface VideoCardProps {
  media?: string;
  title: string;
  description: string;
}

const VideoCard: React.FC<VideoCardProps> = ({ media, title, description }) => {
  return (
    <div className="bg-white h-full p-4 rounded-lg shadow-md duration-300 hover:shadow-lg transition-all">
      {media ? (
      <div className="mb-2">
        <div className="border-[1.5px] rounded-2xl w-full aspect-video overflow-hidden relative">
        <ReactPlayer
          url={media}
          controls={true}
          width="100%"
          height="100%"
          playing={false}
          light={false}
        />
        </div>
      </div>
      ) : (
      <div className="flex bg-gray-200 justify-center rounded-2xl text-gray-500 aspect-video items-center jus mb-2">No media available</div>
      )}
      <h3 className="text-gray-800 text-xl font-semibold mb-2">{title}</h3>
      <p
      className="text-gray-600 text-sm mb-2"
      dangerouslySetInnerHTML={{
        __html: description,
      }}
      />
    </div>
  );
};

export default VideoCard;
